<template>
    <form method="post" @submit.prevent="onSubmit">
        <div class="form-block--main">
            <div class="form__row">
                <div class="form__item form__item--status">
                    <status-autocomplete ref="status" v-model="$v.form.statusId.$model" length-type="w--l"/>
                </div>

                <div class="form__item form__item--active-unit">
                    <form-checkbox label="Aktivní" name="active" :v="$v" v-model="$v.form.active.$model"/>
                </div>
            </div>
            <div class="form__row">
                <div class="form__item">
                    <form-input label="Cena s DPH" :v="$v" name="form.priceVat" @change="onChange" v-model="$v.form.priceVat.$model" length-type="w--xs" suffix="Kč"/>
                </div>

                <div class="form__item">
                    <form-input label="Textová alternativa ceny" :v="$v" name="form.priceAlternative" v-model="$v.form.priceAlternative.$model" length-type="w--l"/>
                </div>
            </div>
        </div>

        <div class="elementary-section__controls button-fix">
            <custom-button type="submit" small outline>Uložit</custom-button>
        </div>
    </form>
</template>

<script>
import {required, decimal} from 'vuelidate/lib/validators';
import FormInput from 'domovio-core/src/components/Form/Input/FormInput';
import StatusContainer from '@/modules/ProjectModule/modules/UnitModule/components/Status/StatusContainer';
import FormCheckbox from 'domovio-core/src/components/Form/Input/FormCheckbox';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import StatusAutocomplete from '@/components/Autocomplete/StatusAutocomplete';

export default {
    name:        'UnitForm',
    components:  {
        StatusAutocomplete,
        CustomButton,
        FormCheckbox,
        StatusContainer,
        FormInput
    },
    data() {
        return {
            form: {
                active:           null,
                priceVat:         null,
                statusId:         null,
                priceAlternative: null,
            },
        }
    },
    validations: {
        form: {
            priceVat:         { required, decimal },
            active:           {},
            priceAlternative: {},
            statusId:         { required },
        },
    },
    methods:     {
        onSubmit() {
            this.$v.$touch();
            if (false === this.$v.$invalid) {
                const { priceVat, active, statusId, priceAlternative } = this.form;
                this.$emit('o3-submit', {
                    active,
                    statusId,
                    priceVat: parseFloat(priceVat),
                    priceAlternative
                });
            }
        },
        onChange(e) {
            const { target } = e;
            if (target && target.name === 'form.priceVat') {
                if (this.form.priceVat && this.form.priceAlternative) {
                    this.form.priceAlternative = null;
                }
            }
        },
        setUnit(unit) {
            const { price, active, priceAlternative, status } = unit;
            this.form.priceAlternative = priceAlternative || null;
            this.form.active = active || false;
            this.form.priceVat = price ? price.withVat : null;

            if (status) {
                this.$refs.status.setSelectedId(status.id);
            }
        }
    }
}
</script>
